import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { CSSTransition } from 'react-transition-group'
import classNames from 'classnames'
import CSSModules from 'react-css-modules'

import SelectButton from 'components/select/button/select_button'
import ClickOutside from 'decorators/click_outside/click_outside_decorator'

import styles from './multi_select_dropdown.scss'

class MultiSelectDropdown extends Component {

	constructor() {
		super()

		this.state = {
			isOpened: false,
			locked: false,
		}
		this.handleClick = this.handleClick.bind(this)
	}

	getCurrentText() {
		const values = this.getCurrentValues()
		const options = this.props.options
		const valuesText = []
		if (options) {
			options.map(option => {
				if (values.indexOf(option.id) > -1) {
					valuesText.push(option.value)
				}
				return valuesText
			})
		}
		if (valuesText.length) {
			return valuesText.join(', ')
		} else if (this.props.placeholder) {
			return this.props.placeholder
		}
		return ''
	}

	getCurrentValues() {
		const isUndefined = val => typeof(val) === 'undefined'
		const isArray = val => Array.isArray(val)
		const {field} = this.props
		const {value, initialValue} = field
		let previousValues = []

		if (!isUndefined(value) && value !== '') {
			previousValues = value
		} else if (!isUndefined(initialValue) && initialValue !== '') {
			previousValues = initialValue
		}

		const currentValues = isArray(previousValues) ? [...previousValues] : [previousValues]

		return currentValues
	}

	handleChange(event, id) {
		const {field} = this.props
		const {onChange} = field
		const values = this.getCurrentValues()

		var index = values.indexOf(id)
		if (index > -1) {
			values.splice(index, 1)
		} else {
			values.push(id)
		}

		if (this.props.onChange) {
			this.props.onChange(values)
		}

		this.setState({ isAnOptionBeingClicked: true })
		if (onChange) {
			onChange(values)
		}
		if (this.props.blurAfterSelect) {
			this.setState({ isOpened: false })
		}
	}

	handleClick() {
		this.setState({ isOpened: !this.state.isOpened })
	}

	handleClickOutside() {
		this.setState({ isOpened: false })
	}

	onFocus() {
		return
		this.setState({ isOpened: true })
	}

	onBlur() {
		return
		this.setState({ isOpened: false })
	}

	listElements(options) {
		const values = this.getCurrentValues()
		if (options) {
			return options.map((option, index) => (
				<li styleName={
					classNames({
						'list-item': true,
						'list-item--selected': (values.indexOf(option.id) > -1),
					})}
				key={index}
				onClick={event => this.handleChange(event, option.id)}
				>
					<span styleName={
						classNames({
							'list-item-bullet': true,
							'list-item-bullet--checkbox': this.props.isCheckmark,
						})
					}>
						<span styleName='list-item-bullet-inner'></span>
					</span>
					<label styleName='list-item-label'>
						{option.value}
					</label>
				</li>
			))
		} else {
			return null
		}
	}

	render() {
		return (
			<ClickOutside clickOutsideHandler={this.handleClickOutside.bind(this)}>
				<div styleName='wrapper'>
					<SelectButton
						onClick={this.handleClick}
						active={this.state.isOpened}
						selected={this.getCurrentValues().length}
						text={this.getCurrentText()}
						fontSize={this.props.fontSize}
						tabIndex={this.props.tabIndex}
						onFocus={this.onFocus.bind(this)}
						onBlur={this.onBlur.bind(this)}
					/>
					{/* Classes that determine list's position: 'position-top', 'position-bottom' */}
					<CSSTransition
						in={this.state.isOpened}
						classNames={{
							enter: styles.enter,
							enterActive: styles['enter-active'],
							exit: styles.exit,
							exitActive: styles['exit-active'],
						}}
						timeout={300}
						unmountOnExit
					>
						<ul
							styleName={
								classNames({
									list: true,
									'position-top': this.props.positionTop,
								})
							}
						>
							{this.listElements(this.props.options)}
						</ul>
					</CSSTransition>
				</div>
			</ClickOutside>
		)
	}
}

MultiSelectDropdown.propTypes = {
	fontSize: PropTypes.oneOf(['small', 'medium', 'big']),
	blurAfterSelect: PropTypes.bool,
	options: PropTypes.array,
	field: PropTypes.object,
	placeholder: PropTypes.string,
	onChange: PropTypes.func,
	tabIndex: PropTypes.number,
	isCheckmark: PropTypes.bool,
	positionTop: PropTypes.bool,
}

MultiSelectDropdown.defaultProps = {
	fontSize: 'small',
	blurAfterSelect: false,
	options: [],
	field: {},
	placeholder: '',
	tabIndex: 0,
	isCheckmark: false,
	positionTop: true,
}

export default CSSModules(MultiSelectDropdown, styles, {allowMultiple: true})
